import { useRef, useState } from "react";
import { Camera, Trash, UserCircle } from "@phosphor-icons/react";
import { toast } from "sonner";
import API from "../../lib/api";
import { Button } from "../ui/button";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

/** Logo / headshot shown on the public partner page. `endpoint` is the POST/DELETE path (admin or portal). */
export function PartnerPhoto({ photoUrl, endpoint, onChanged, size = 72, canEdit = true, testId = "partner-photo" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    setBusy(true);
    try { await API.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Photo updated"); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't upload that image"); }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };
  const remove = async () => {
    setBusy(true);
    try { await API.delete(endpoint); toast.success("Photo removed"); onChanged?.(); } catch { toast.error("Couldn't remove the photo"); }
    setBusy(false);
  };
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <div className="rounded-full overflow-hidden border border-border bg-muted flex items-center justify-center shrink-0" style={{ width: size, height: size }}>
        {photoUrl ? <img src={`${API_BASE}${photoUrl}`} alt="Partner" className="h-full w-full object-cover" data-testid={`${testId}-img`} /> : <UserCircle size={size * 0.7} className="text-muted-foreground" weight="duotone" />}
      </div>
      {canEdit && (
        <div className="flex flex-col gap-1">
          <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testId}-input`} />
          <Button variant="outline" size="sm" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testId}-upload`}><Camera size={14} className="mr-1" /> {photoUrl ? "Change photo" : "Add logo or photo"}</Button>
          {photoUrl && <Button variant="ghost" size="sm" onClick={remove} disabled={busy} data-testid={`${testId}-remove`}><Trash size={14} className="mr-1" /> Remove</Button>}
          <p className="text-[10px] text-muted-foreground">PNG, JPEG or WebP · max 3 MB · square works best</p>
        </div>
      )}
    </div>
  );
}
